import React, { Component } from "react";
import { FormValidate } from "../../../../components/formValidate";
import CustomButton from "../../../../components/inputs/button";
import TextField from "../../../../components/inputs/textfield";
import Snackbar from "../../../../components/snackbar/snackbar";
import Loader from "../../../../components/loader/loader";
import {
  admin_draft_policy_add,
  admin_draft_policy_edit,
} from "../../admin.api";
import "../../policies/manage/dialog.css";
import TextEditer from "../../../../components/inputs/texteditor";

let required = ["title", "title_ma"];

class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      formData: props.formData || {},
      edit: props.edit,
      view: props.view,
      isActive: false,
      submitted: false,
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
      docEngError: false,
      docMalError: false,
    };
  }

  componentWillReceiveProps = (props) => {
    this.setState({
      open: props.open,
      edit: props.edit,
      view: props.view,
      formData: props.formData || {},
    });
  };

  handleEditorChange = (value, fieldName) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [fieldName]: value,
      },
    });
  };

  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState({ formData: { ...this.state.formData, [name]: value } });
  };

  handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];

    if (!file) return;

    const size = file.size;
    const type = file.name.split(".").pop().toLowerCase();
    const mb = size / (1024 * 1024);

    if (type === "pdf") {
      if (mb <= 10) {
        this.setState({
          [fieldName === "document_eng" ? "docEngError" : "docMalError"]: false,
          formData: {
            ...this.state.formData,
            [fieldName]: file,
            [`${fieldName}_name`]: file.name,
          },
        });
      } else {
        this.setState({
          [fieldName === "document_eng" ? "docEngError" : "docMalError"]: true,
          snackMessage: "File size should not exceed 10MB",
          isSnackError: true,
          snackOpen: true,
        });
        e.target.value = null;
      }
    } else {
      this.setState({
        [fieldName === "document_eng" ? "docEngError" : "docMalError"]: true,
        snackMessage: "Only PDF files are allowed",
        isSnackError: true,
        snackOpen: true,
      });
      e.target.value = null;
    }
  };

  snackbarClose = (flag) => {
    this.setState({
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    });
    if (!flag) {
      this.props.handleClose();
    }
  };

  handleDateChange = (e) => {
    const value = e.target.value;
    this.setState({
      formData: {
        ...this.state.formData,
        feedback_last_date: value,
      },
    });
  };

  handleSubmit = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const error = FormValidate(this.state.formData, required);
    const { edit, formData } = this.state;

    if (Object.keys(error).length > 0) {
      this.setState({
        submitted: true,
        snackMessage: "Please fill required fields",
        isSnackError: true,
        snackOpen: true,
      });
      return;
    }

    let payload = new FormData();

    Object.keys(formData).forEach((key) => {
      const value = formData[key];

      if (key === "document_eng" || key === "document_mal") {
        if (value && typeof value !== "string" && value instanceof File) {
          payload.append(key, value);
        }
      } else {
        if (value !== null && value !== undefined && value !== "null" && value !== "undefined") {
          payload.append(key, value);
        }
      }
    });

    this.setState({ isActive: true });

    const apiCall = edit
      ? admin_draft_policy_edit(formData?.id, payload)
      : admin_draft_policy_add(payload);

    apiCall
      .then((res) => {
        this.setState({
          submitted: true,
          isActive: false,
          snackMessage: res.message || "Saved successfully",
          isSnackError: false,
          snackOpen: true,
        });
      })
      .catch((error) => {
        let errorMsg = "Error saving record";
        if (error?.response?.data?.error) {
          const errObj = error.response.data.error;
          const firstKey = Object.keys(errObj)[0];
          if (firstKey && errObj[firstKey][0]) {
            errorMsg = errObj[firstKey][0];
          }
        } else if (error?.data?.message) {
          errorMsg = error.data.message;
        } else if (error?.message) {
          errorMsg = error.message;
        }

        this.setState({
          submitted: false,
          isActive: false,
          snackMessage: errorMsg,
          isSnackError: true,
          snackOpen: true,
        });
      });
  };

  render() {
    const { open, edit, view, formData, submitted, isActive } = this.state;
    const error = FormValidate(formData, required);

    return (
      open && (
        <div>
          <div className="dia-bg">
            <div
              className="big-dia-scroll"
              style={{
                display: "flex",
                flexDirection: "column",
                maxHeight: "90vh",
                height: "auto",
              }}
            >
              <h5 className="modal-title fw-bold p-3 border-bottom m-0">
                {view
                  ? "View Draft Policy"
                  : edit
                    ? "Update Draft Policy"
                    : "Add Draft Policy"}
              </h5>
              <form onSubmit={this.handleSubmit} style={{ display: "contents" }}>
                <div
                  className="content-scroll-xx2"
                  style={{ flex: 1, overflowY: "auto", padding: "15px" }}
                >
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <TextField
                      id="title"
                      name="title"
                      label="Title [Eng]"
                      type="text"
                      onChange={this.handleChange}
                      disabled={view}
                      value={formData.title || ""}
                      error={submitted && error.title}
                      required={true}
                    />
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                    <TextField
                      id="title_ma"
                      name="title_ma"
                      label="Title [Mal]"
                      type="text"
                      onChange={this.handleChange}
                      disabled={view}
                      value={formData.title_ma || ""}
                      error={submitted && error.title_ma}
                      required={true}
                    />
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                    <label className="form-label font-12">Description [Eng]</label>
                    <TextEditer
                      value={formData.description || ""}
                      onChange={(v) => this.handleEditorChange(v, "description")}
                      disabled={view}
                    />
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                    <label className="form-label font-12">Description [Mal]</label>
                    <TextEditer
                      value={formData.description_ma || ""}
                      onChange={(v) => this.handleEditorChange(v, "description_ma")}
                      disabled={view}
                    />
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                    <label className="form-label font-12">Feedback Last Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="feedback_last_date"
                      value={formData.feedback_last_date || ""}
                      onChange={this.handleDateChange}
                      disabled={view}
                    />
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                    <label className="form-label font-12">Document [Eng] (PDF, Max 10MB)</label>
                    {!view && (
                      <input
                        type="file"
                        className="form-control"
                        accept=".pdf"
                        onChange={(e) => this.handleFileChange(e, "document_eng")}
                      />
                    )}
                    {formData.document_eng && typeof formData.document_eng === "string" && (
                      <div className="mt-1 font-12 text-muted">
                        Current File: {formData.document_eng}
                      </div>
                    )}
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                    <label className="form-label font-12">Document [Mal] (PDF, Max 10MB)</label>
                    {!view && (
                      <input
                        type="file"
                        className="form-control"
                        accept=".pdf"
                        onChange={(e) => this.handleFileChange(e, "document_mal")}
                      />
                    )}
                    {formData.document_mal && typeof formData.document_mal === "string" && (
                      <div className="mt-1 font-12 text-muted">
                        Current File: {formData.document_mal}
                      </div>
                    )}
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                    <TextField
                      id="feedback_form"
                      name="feedback_form"
                      label="Feedback Form Link"
                      type="text"
                      onChange={this.handleChange}
                      disabled={view}
                      value={formData.feedback_form || ""}
                    />
                  </div>
                </div>
                <div
                  className="footer-btn d-flex justify-content-end align-items-center p-3"
                  style={{ borderTop: "1px solid #e9ecef" }}
                >
                  <button
                    type="button"
                    className="btn btn-danger btn-sm px-4 me-2"
                    onClick={this.props.handleClose}
                  >
                    {view ? "Close" : "Cancel"}
                  </button>
                  {!view && (
                    <button
                      type="button"
                      className="btn btn-primary btn-sm px-4 ms-2"
                      onClick={(e) => this.handleSubmit(e)}
                    >
                      {edit ? "Update" : "Add"}
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
          <Loader open={isActive} />
          <Snackbar
            message={this.state.snackMessage}
            error={this.state.isSnackError}
            open={this.state.snackOpen}
            close={this.snackbarClose}
          />
        </div>
      )
    );
  }
}

export default Dialog;
